import { Card, CardContent } from "@material-ui/core";
import React from "react";
import "../css/InfoBox.css";

function InfoBox({ topic, value, color }) {
  return (
    <Card className="infoBox">
      <CardContent>
        <h4>{topic}</h4>
        <p className={color}>
          {topic === "New Cases" ? "+" : ""}
          {value}
        </p>
      </CardContent>
    </Card>
  );
}

export default InfoBox;
